cv.currencySign = function(currency_code){
  switch(currency_code){
    case 'EUR':
      return '\u20ac';
      break;
    case 'GBP':
      return '\u00A3';
      break;
    case 'CHF':
      return 'CHF';
      break;
    case 'SEK':
    case 'NOK':
    case 'DKK':
      return 'kr ';
      break;
    case 'ZAR':
      return 'ZAR ';
      break;
    case 'XCD':
      return 'XCD$';
      break;
    case 'AWG':
      return 'AWG$';
      break;
    case 'BSD':
      return 'BSD$';
      break;
    case 'BBD':
      return 'BBD$';
      break;
    case 'KYD':
      return 'KYD$';
      break;
    case 'ANG':
      return 'ANG$';
      break;
    case 'JMD':
      return 'JMD$';
      break;
    case 'TTD':
      return 'TTD$';
      break;
    case 'JPY':
      return '\xa5';
      break;
    default:
      return '$';
  }
};
